// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__diygv","title":"ClientInsurance_title__1OF71","itemText":"ClientInsurance_itemText__1rOaY"};